import type { OrgNode, TSlackBot, TUser } from "@/types"
import { api } from "./api"
import { generateAPIResource } from "./utils"

export const orgNodeAPI = generateAPIResource<OrgNode>("/people/orgnodes")

export async function fetchAPISlackBot() {
  const { data } = await api.get<TSlackBot>("/people/slack")
  return data
}

export async function updateAPISlackBot(meta: TSlackBot["meta"]) {
  const { data } = await api.put<TSlackBot>("/people/slack", meta)
  return data
}

export async function importAPIUsersCSV(file: File) {
  const formData = new FormData()
  formData.append("csv", file)
  const { data } = await api.post<{ processed: number }>("/people/export/users.csv", formData)
  return data
}

export async function fetchAPISlackTeamUsers() {
  const res = await api.get("/people/team/import")
  return res.data as TUser[]
}

export async function importAPISlackTeam(ids: string[]) {
  const res = await api.post("/people/team/import", ids)
  return res.data as TUser[]
}

export async function importAPISlackGroups() {
  await api.post("/people/team/groups/import")
}

export async function syncAPISlackTeam() {
  const res = await api.post("/people/team/sync")
  return res.data
}
